/** Page « introuvable » : une adresse inconnue (lien ancien, faute de frappe) mène quelque part, jamais à une page nue. */
import { Link } from "@tanstack/react-router";
import { ArrowLeft, Compass } from "lucide-react";
import { useTitreDocument } from "../ui/base";
import { Marque } from "../ui/marque";

export function PageIntrouvable() {
  useTitreDocument("Page introuvable");
  return (
    <main className="grid min-h-dvh place-items-center bg-papier px-4 py-16">
      <div className="max-w-md text-center">
        <Marque taille="h-6" className="mx-auto mb-10 block w-fit" />
        <div className="mx-auto mb-4 grid size-14 place-items-center rounded-full bg-papier-3 text-encre-2">
          <Compass className="size-7" aria-hidden />
        </div>
        <h1 className="text-[24px] leading-tight font-semibold">Cette page n'existe pas</h1>
        <p className="mt-2 text-encre-2">L'adresse est peut-être ancienne ou mal recopiée. Les dossiers, formations et coffres s'ouvrent depuis le menu de l'application.</p>
        <Link to="/" className="mt-6 inline-flex h-10 items-center gap-2 rounded-sm bg-accent px-4 text-sm font-medium text-sur-accent shadow-carte hover:bg-accent-fort">
          <ArrowLeft className="size-4" aria-hidden />
          Revenir à l'accueil
        </Link>
      </div>
    </main>
  );
}
